import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Card, Input } from 'antd';
import { Formik } from 'formik';
import React from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import axios from 'axios';
import { API_KEY } from '../../constants';
import firebase from '../../config/firebase';

export const GET_MONITOR_KEY = gql`
	query GetMonitor($password: String!) {
		monitores(where: { password: { _eq: $password } }) {
			key
			firebase_uid
			nombre
			active
			institucion {
				key
				nombre
			}
		}
	}
`;

const SignInMonitor = () => {
	const [getMonitor, { loading }] = useLazyQuery(GET_MONITOR_KEY, {
		onCompleted: ev => {
			if (ev.monitores.length > 0 && ev.monitores[0].active) {
				axios
					.post(`${API_KEY}/auth/signInMonitor`, {
						login: {
							uid: ev.monitores[0].firebase_uid,
							hasuraKey: ev.monitores[0].key,
							tipoUsuario: 'monitor'
						}
					})
					.then(res => {
						firebase
							.auth()
							.signInWithCustomToken(res.data.token)
							.catch(function(error: any) {
								return error;
							});
					});
			}
		}
	});

	if (loading) {
		return null;
	}

	return (
		<Card title="Sign in Monitor" style={{ width: '100%' }}>
			<Formik
				initialValues={{ password: '' }}
				onSubmit={values => {
					getMonitor({ variables: { password: values.password } });
				}}
				render={(formikProps: any) => (
					<Form layout="vertical">
						<Form.Item label="Ingresa tu clave secreta">
							<Input
								type="password"
								name="password"
								onChange={val => {
									formikProps.handleChange(val);
								}}
								onBlur={formikProps.handleBlur}
								value={formikProps.values.password}
							/>
						</Form.Item>
						<Form.Item>
							<Button type="primary" onClick={formikProps.handleSubmit} color="primary">
								Submit
							</Button>
						</Form.Item>
					</Form>
				)}
			/>
		</Card>
	);
};

export default SignInMonitor;
